module.exports = __webpack_public_path__ + "img/eat_out_13.9c6f8e8b.jpg";